import { useState } from "react";
import { motion } from "framer-motion";
import LetsConnectButton from "./LetsConnectButton";
import HolographicContactModal from "./HolographicContactModal";

export default function HeroSection() {
  const [showHoloModal, setShowHoloModal] = useState(false);

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden pb-24 md:pb-32"
    >
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source
            src="/assets/hero.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content - Left aligned */}
      <div className="relative z-10 container mx-auto px-6 md:px-12 max-w-[1400px]">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1
            data-testid="hero-title"
            className="font-syne text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1] text-white mb-10 max-w-[700px]"
          >
            Elevating Brands Through{" "}
            <span className="gradient-text">Creative Precision</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        >
          <LetsConnectButton 
            onClick={() => setShowHoloModal(true)}
            data-testid="hero-cta-button"
          />
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="w-[1px] h-16 bg-gradient-to-b from-white/50 to-transparent" />
      </motion.div>

      {/* Holographic Contact Modal */}
      <HolographicContactModal 
        isOpen={showHoloModal} 
        onClose={() => setShowHoloModal(false)} 
      />
    </section>
  );
}
